import { ThemeProvider, createTheme } from '@mui/material';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import React, { useState, useRef } from 'react';
const customTheme = createTheme({
  palette: {
    primary: {
      main: "#0000000a",
    },
  },
});

const initialPagination = {
  pageIndex: 0,
  pageSize: 10,
};

function CustomTable({
  data,
  columns,
  isLoading,
  defaultColumn = {},
  enableColumnPinning = true,
  enableHiding = false,
  setSelectedRowIndex,
  enableExpandAll = false,
  enablePagination = false,
  enableGrouping = false,
  groupedColumnMode = 'reorder',
  enableTopToolbar = true,
  enableBottomToolbar = true,
  searchIconVisible = false,
  enableColumnResizing = true,
  enableColumnFilter = false,
  enableDensityToggle = false,
  enableColumnOrdering = false,
  enableStickyHeader = true,
  autoResetPageIndex = false,
  enableFilterMatchHighlighting = true,
  paginateExpandedRows = false,
  enableRowSelection = false,
  enableColumnFilters = false,
  enableGlobalFilter = true,
  enableColumnActions = true,
  enableFullScreenToggle = false,
  positionToolbarAlertBanner = 'bottom',
  positionPagination = 'bottom',
  enableGlobalFilterModes = true,
  globalFilterModeOptions = ['fuzzy', 'startsWith', 'contains'],
  layoutMode = 'semantic',
  initialState = {},
  density = 'compact',
  positionGlobalFilter = 'left',
  optionalProps = {},
  rowSelection = {},
  enableExpanding = false,
  getSubRows = false,
  columnOrder = [],
  filterFromLeafRows = true,
  tableKey = ''
}) {
  const [columnFilters, setColumnFilters] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState(defaultColumn);
  const [globalFilter, setGlobalFilter] = useState(undefined);
  const [showGlobalFilter, setShowGlobalFilter] = useState(true);
  const [showColumnFilters, setShowColumnFilters] = useState(false);
  // const [rowSelection, setRowSelection] = useState({});
  const [sorting, setSorting] = useState([]);
  const [expanded, setExpanded] = useState(initialState.expanded ?? false);
  const [pagination, setPagination] = useState(initialPagination);

  const isInitialRender = useRef(true);

  const table = useMaterialReactTable({
    columns,
    data,
    enableExpandAll,
    enableGrouping,
    groupedColumnMode,
    enableColumnPinning,
    enableTopToolbar,
    enableBottomToolbar,
    searchIconVisible,
    enableHiding,
    enablePagination,
    enableColumnResizing,
    enableColumnFilter,
    enableDensityToggle,
    enableColumnOrdering,
    autoResetPageIndex,
    enableFilterMatchHighlighting,
    paginateExpandedRows,
    enableRowSelection,
    enableColumnActions,
    enableStickyHeader,
    positionToolbarAlertBanner,
    positionPagination,
    enableGlobalFilterModes,
    enableColumnFilters,
    enableGlobalFilter,
    enableFullScreenToggle,
    globalFilterModeOptions,
    positionGlobalFilter,
    filterFromLeafRows,
    layoutMode,
    enableExpanding,
    getSubRows,
    initialState,
    state: {
      isLoading,
      density,
      columnVisibility,
      columnFilters,
      globalFilter,
      sorting,
      showColumnFilters,
      showGlobalFilter,
      rowSelection,
      pagination,
      columnOrder,
      expanded: columnFilters?.length > 0 || !!globalFilter ? true : expanded,
    },
    ...optionalProps,
    columnFilterDisplayMode: 'custom',
    onColumnVisibilityChange: setColumnVisibility,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onShowColumnFiltersChange: setShowColumnFilters,
    onSortingChange: setSorting,
    onExpandedChange: setExpanded,
    onPaginationChange: setPagination,
    muiPaginationProps: {
      rowsPerPageOptions: [10, 20, 50, 100],
    },
    muiTableContainerProps: { sx: { maxHeight: '450px' } },
    muiTableBodyProps: {
      sx: {
        //stripe the rows, make odd rows a darker color
        '& tr:nth-of-type(even) > td': {
          backgroundColor: tableKey !== 'InventoryDetails' ? '#0000000a' : '',
        },
      },
    },
    muiTableBodyCellProps: ({ row }) => ({
      align: "left",
      sx: {
        fontWeight: row.getCanExpand() ? 'bold' : 'normal',
        borderRight: '1px solid rgb(224 224 224)',
        backgroundColor: (row.getCanExpand() && tableKey === 'InventoryDetails') ? '#0000000a' : '',
      },
    }),
    muiTableHeadCellProps: {
      sx: (theme) => ({

        fontSize: '15px',
        borderRight: '1px solid rgb(224 224 224)',

        fontWeight: '500',
        color: '#6c757d',
        boxShadow: 'none'
      }),
    },
    muiBottomToolbarProps: {
      sx: {
        backgroundColor: '#fff',
      }
    },
    muiTopToolbarProps: {
      sx: {
        borderBottom: '1px solid rgb(224 224 224)',
      }
    },
    muiTableFooterCellProps: {
      sx: {
        border: 'none',
      }
    },
  });

  return (
    <>
      {/* <ThemeProvider theme={customTheme}> */}
      <MaterialReactTable table={table} />
      {/* </ThemeProvider> */}
    </>
  )
}

export default CustomTable;
